module.exports = __webpack_public_path__ + "img/bg-top.fd7115ad.png";